'use es6';

import * as REQUEST_STATES from 'forms-utils-lib/RequestState';
import { handleAction } from 'redux-actions';
import { requestSubmissionBootstrap, requestSubmissionBootstrapFail, requestSubmissionBootstrapSuccess } from 'FormsUI/actions/SubmissionsBootstrap';
import reduceReducers from 'FormsUI/utils/ReduceReducers';
const initialState = {
  formSpecificItems: {},
  objectTypeLabels: {}
};
export const requestSubmissionBootstrapReducer = handleAction(requestSubmissionBootstrap, (state, action) => Object.assign({}, state, {
  formSpecificItems: Object.assign({}, state.formSpecificItems, {
    [action.payload.formGuid]: {
      requestState: REQUEST_STATES.REQUESTED,
      fields: [],
      mostRecentSubmissionTimestamp: null,
      error: null
    }
  })
}), initialState);
export const requestSubmissionBootstrapSuccessReducer = handleAction(requestSubmissionBootstrapSuccess, (state, action) => Object.assign({}, state, {
  objectTypeLabels: action.payload.payload.objectTypeLabels || state.objectTypeLabels,
  formSpecificItems: Object.assign({}, state.formSpecificItems, {
    [action.payload.formGuid]: Object.assign({
      requestState: REQUEST_STATES.SUCCEEDED
    }, action.payload.payload, {
      error: null
    })
  })
}), initialState);
export const requestSubmissionBootstrapFailReducer = handleAction(requestSubmissionBootstrapFail, (state, action) => Object.assign({}, state, {
  formSpecificItems: Object.assign({}, state.formSpecificItems, {
    [action.payload.formGuid]: Object.assign({
      requestState: REQUEST_STATES.FAILED,
      fields: [],
      mostRecentSubmissionTimestamp: null
    }, action.payload.payload)
  })
}), initialState);
export default reduceReducers(requestSubmissionBootstrapReducer, requestSubmissionBootstrapSuccessReducer, requestSubmissionBootstrapFailReducer);